const rosteringHeavenUrl = '/rostering-heaven';

export default rosteringHeavenUrl;
